import { render, staticRenderFns } from "./query_tab.vue?vue&type=template&id=24ef28e4&scoped=true"
import script from "./query_tab.vue?vue&type=script&lang=js"
export * from "./query_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef28e4",
  null
  
)

export default component.exports